'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AmexCardLogo = function AmexCardLogo(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 145.27 93.77"
  }), React__default["default"].createElement("defs", null, React__default["default"].createElement("style", null, ".amex-card-logo-blue-fill{fill:#007cc1}")), React__default["default"].createElement("g", null, React__default["default"].createElement("rect", {
    x: 2.9,
    y: 2.9,
    width: 139.47,
    height: 87.96,
    rx: 8.78,
    ry: 8.78,
    style: {
      fill: "none",
      stroke: "#151a1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.81px"
    }
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    className: "amex-card-logo-blue-fill",
    d: "M129.77 62.72h-16.96c-1.4-1.55-2.99-3.31-4.77-5.29l-4.77\n            5.21H39.92l-2.24-5.61h-5.15l-2.25 5.71H15.35c4.4-10.53 8.68-21.37\n            12.99-31.69 4.5 0 8.89.02 13.3 0 .63 1.28 1.24 3.15 2.26 5.32.14-2.3.23-3.76.32-5.32h15.59c1.28 2.77\n            2.67 5.92 4.32 9.5 1.55-3.41 2.89-6.43 4.28-9.5h35.62c1.31 1.52 2.72 3.23 4.31 5.07l4.5-5.07h17.06c-4.4\n            5.42-8.52 10.5-12.81 15.79 4.11 5.16 8.21 10.3 12.66 15.89Zm-98.5-27.49c-3.25 7.77-6.45 15.44-9.73\n            23.29h5.93l2.26-5.63h10.75l2.25 5.56h11.38V41.57l7.36 16.91h5.33c2.19-5.3 4.32-10.48\n            7.15-17.33V58.5h6.28V35.28h-9.18c-2.26 5.01-4.49 9.98-6.91\n            15.34-2.5-5.53-4.74-10.51-6.87-15.23h-9.32v21.44l-9.12-21.58h-7.56Zm70.18 23.26c2.21-2.43\n            4.39-4.82 6.64-7.3l6.44 7.26h6.57c-3.25-4.08-6.22-7.8-9.26-11.62 3.03-3.76 6.02-7.46\n            9.28-11.51h-6.56l-6.28 7.22c-2.2-2.64-4.23-5.07-5.96-7.15H84.3v23.09h17.16Z"
  }), React__default["default"].createElement("path", {
    className: "amex-card-logo-blue-fill",
    d: "m34.92 39.96 3.33 7.7h-6.51l3.19-7.7ZM97.76 48.91v-4h-7.6v-4.82h9.14l5.2 6.71c-2.08 2.39-4.04 4.65-5.9 6.8h-8.42l-.25-4.7h7.82Z"
  }))));
};

var AmexCardLogo$1 = iconStyles()(AmexCardLogo);

module.exports = AmexCardLogo$1;
